<template>
  <div class="content">
    <div class="index-number">
      <div
        class="risk-list"
        v-show="result.data && Object.keys(result.data).length > 0"
      >
        <div class="risk-item">
          <span>日期</span>
          <div
            class="index-header"
            v-for="(item, index) in result.times"
            :key="index + ''"
          >
            {{ formatDateStr(item) }}
          </div>
        </div>
        <div class="risk-item" v-for="(item, key) in result.data" :key="key">
          <span style="white-space: nowrap; transform: scale(0.95)">{{
            key + "适宜性"
          }}</span>
          <div
            style="transform: scale(0.85)"
            v-for="index1 in result.times.length"
            :key="index1 + ''"
          >
            <div
              :class="{
                suitableValue: true,
                suitable: item[index1 - 1] == 1,
                'more-suitable': item[index1 - 1] == 2,
                indisposition: item[index1 - 1] == 3 || item[index1 - 1] == 0,
              }"
            >
              {{ suitableMap[item[index1 - 1]] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: ["params", "forecastType"],
  data() {
    return {
      suitabilityNumber: {},
      suitableMap: {
        0: "不适宜",
        1: "适宜",
        2: "较适宜",
        3: "不适宜",
      },
    };
  },

  watch: {
    suitabilityNumberResult(id) {
      setTimeout(() => {
        this.getRiskData();
      }, 100);
    },
    tqskDateResult: {
      handler() {
        setTimeout(() => {
          this.getRiskData();
        }, 100);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "cartData",
      "suitabilityNumberResult",
    ]),
    result() {
      const suitabilityNumber = this.suitabilityNumber;
      if (suitabilityNumber.times) {
        suitabilityNumber.times = suitabilityNumber.times.slice(0, 5);
        for (const key in suitabilityNumber.data) {
          suitabilityNumber.data[key] = suitabilityNumber.data[key].slice(0, 5);
        }
      }
      console.log("5suitabilityNumber", suitabilityNumber);
      return suitabilityNumber;
    },
  },
  mounted() {
    setTimeout(() => {
      this.getRiskData();
    }, 100);
  },
  methods: {
    ...mapMutations("home", ["changeCartItem"]),
    /**
     * 短临风险
     */
    async getRiskData() {
      this.suitabilityNumber = this.suitabilityNumberResult;
    },
    formatDateStr(dateStr) {
      return dateStr.replace("月", "-").replace("日", "");
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.8vw 1.04vw 1.04vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;

  .short-risk {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
  }

  .index-number {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
    // width: 38.31rem;
  }

  .risk-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .risk-item {
      font-size: 0.88rem;
      color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 0.4vw;

      .index-header {
        width: 2.4vw;
      }

      .suitableValue {
        width: 2.5vw;
        text-align: center;
        height: 1.15vw;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .suitable {
        background: rgba(10, 249, 235, 0.2);
        border-radius: 3px;
        border: 1px solid #0af9eb;
        color: #0af9eb;
      }

      .more-suitable {
        background: rgba(255, 228, 17, 0.2);
        border-radius: 3px;
        border: 1px solid #ffe411;
        color: #ffe411;
      }

      .indisposition {
        background: rgba(255, 120, 134, 0.2);
        border-radius: 3px;
        border: 1px solid #ff5567;
        color: #ff5567;
      }

      &:hover {
        cursor: pointer;
      }

      span:nth-child(1) {
        text-align: center;
        width: 3.64vw;
      }

      span {
        width: 74px;
        display: inline-block;
        text-align: center;
        margin: 0vw 0.16vw;

        i {
          display: inline-block;
          position: relative;
          width: 3.27rem;
          height: 0.63rem;
          //background: #295073;
          background: #3a678f;
          border-radius: 0.31rem;

          &:hover {
            .pounp {
              display: block;
            }
          }

          .pounp {
            display: none;
            position: absolute;
            bottom: 0.8vw;
            left: 50%;
            transform: translateX(-50%);
            width: 3.27rem;
            height: 1.36vw;
            line-height: 1.36vw;
            background: #052c4d;
            color: #fff;
            box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;

            &::after {
              content: "";
              display: inline-block;
              position: absolute;
              left: 50%;
              bottom: -10px;
              transform: translateX(-50%);
              border: 5px solid transparent;
              border-top-color: rgba(255, 255, 255, 0.8);
              box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            }
          }
        }
      }
    }

    .risk-item:nth-child(1) {
      height: 2.14vw;
      background: #052c4d;
      border-radius: 0.21vw;
    }
  }
}
</style>
